import { render, staticRenderFns } from "./file-list.vue?vue&type=template&id=0b06503c&scoped=true&"
import script from "./file-list.vue?vue&type=script&lang=js&"
export * from "./file-list.vue?vue&type=script&lang=js&"
import style0 from "./file-list.vue?vue&type=style&index=0&id=0b06503c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06503c",
  null
  
)

export default component.exports